import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'button-specs',
  templateUrl: './button-specs.component.html',
  styleUrls: ['./button-specs.component.sass']
})
export class ButtonSpecsComponent implements OnInit {
  public component = window.location.protocol + '//' + window.location.host + '/design-specs-measure/contained-button/';

  constructor() { }

  ngOnInit(): void {
  }

  clickEvent(route) {
    if(route == 'light') {
      window.open(this.component, "_blank");
    }
  }

}
